<section class="healthcare-banner instool aashi">
    <div class="container">
        <div class="row zmc">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12 service-heading">
                <div class="headtext">
                    <h1>Spend less time getting lost and more time growing your business. </h1><br>
                    <title>Zonsteps Case Study - Footwear E-Commerce Development | Vidhema</title>
                    <!-- <p >We design and build superior digital products, delegating seamless user experiences across all modern platforms and devices and helping brands to expand their business globally. -->
                    <!-- </p><a  routerLink="/getaquote.html"
                                            class="ar_contect-industries-header"><span
                                                    >Request a Free
                                                    Quote</span></a> -->
                </div>
            </div>
        </div>
    </div>

</section>
<div class="casestudy-details pt-120 pb-120">
    <div class="container logo-box">
        <img class="ilast-logo"
            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/ZonSteps%20logo.jpg?alt=media&token=d63c59c8-d9f5-4f98-aa41-b63cc9605c02">
    </div>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-8">
                <div class="case-details-single">
                    <h2>ZonSteps
                    </h2>
                    <p class="para mb-30">
                        Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set
                        up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time
                        image of your Amazon business to optimize it and progress you toward a successful journey.
                    </p>
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/business-brainstorming-graph-chart-report-data-concept.jpg?alt=media&token=13b08170-33a4-4d1f-aa11-1a3f03713e81"
                        alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="case-sidebar-area">
                    <ul class="case-info-list">
                        <li>
                            <span>
                                <img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team Size :
                            </span>
                            <h5>
                                5 Members
                            </h5>
                            <h5>

                                Developer | Designer | BA | QA

                            </h5>
                        </li>

                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Duration :</span>
                            <h5> 2 Year</h5>
                        </li>
                        <!-- <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team:</span>
                           
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="case-details-single">

                    <div class="area">
                        <h4>Who is the client?</h4>
                        <p class="para">
                            The client is based out of Australia. ZonSteps is a website based on businesses that can add
                            their Amazon
                            products via ZonSteps. You can even try the ZonSteps for free. It shows the checklist of all
                            the categories where users can add all the items easily by following the proper steps.
                        </p>
                    </div>
                    <div class="area">
                        <h4>Purpose of the Client
                        </h4>

                        <p class="para">
                            Amazon sellers get fast results with ZonSteps.
                            The client came across Vidhema Technologies having an idea for ZonSteps. They had the idea
                            that users can add items for their business to get listed on Amazon easily and drive enough
                            traffic to their Amazon business listing.

                        </p>

                        <p class="para">
                            The client wanted our team of developers to develop a website from scratch where we have to
                            integrate all the required features and functionalities. There were many challenges we had
                            to face while developing the website. The client had the whole idea of the website with all
                            the features.
                        </p>


                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <div class="case-details-single">
                        <div class="area">
                            <h4>Challenges
                            </h4>
                            <p class="para"> </p>
                            <p>

                                The main challenge faced by the client was to have a website that can be easily
                                navigated by users.
                                After having all the ideas in mind, they came up with the project for Vidhema
                                Technologies. There was a discussion related to the website outlook and features. There
                                were several ideas that our team and client mutually discussed to implement on the
                                website. The features that were implemented in the website are set to be done with every
                                phase and proper process.

                            </p>
                        </div>

                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <img src="assets/images/c-intro.svg" alt="Intro">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4>Solutions:</h4>
                        <p class="para">

                            Our team of engineers developed the interface of the website quite engaging.
                            We had a mutual discussion related to the several functionalities and features of the
                            website.
                            The client had documentation of the front end and back end of the website.
                        </p>

                        <p class="para">

                            At the time, our team prepared the structure of the website.
                            The solutions provided by us were to gain the maximum number of users on the website.
                        </p>


                        <p class="para">
                            The main focus that we had was on the automation and admin panel of the page. The automation
                            and admin panel for the project was unique while keeping in mind the audience and their
                            businesses.
                            There are various categories available for all the businesses that can be added to the
                            listing. The users can take the subscription to add their business to the Amazon listing.
                        </p>
                       
                    </div>

                    <div class="area">
                        <h4>Results</h4>
                        <p class="para">
                            When we launched the deployed website, it did amazingly well in order to engage audiences.
                            People navigated the website easily while adding their businesses to Amazon’s listing. This
                            was in all a great success for the ZonSteps website.

                        </p>
                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">

                                The UI/UX of the website was designed by including all the functionalities and features
                                of the website.
                            </p>
                        </div>
                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">

                                The engagement to the website was pretty good and users will be able to add their
                                businesses accordingly. </p>
                        </div>
                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                The checklist on the website showed step-by-step features that will be less
                                time-consuming for the users.
                            </p>
                        </div>

                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                The checklist for the users was designed in such a way that they can single-handedly add
                                their business items without any hassle or complications.

                            </p>
                        </div>

                        <div class="list-title list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                There is a drag and drop implemented in the checklist feature by which users can
                                effortlessly enter their products by just dragging and dropping them.

                            </p>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4>Technologies and Tools </h4>
                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/React%20js.png?alt=media&token=44b17a39-f74d-4339-8cda-3aee9705b6f9"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Angular</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/node%20js.png?alt=media&token=c37cf052-b478-49a4-b1b1-f21102accaa8"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>

                        </ul>
                    </div>
                    <div class="area">
                        <h4>Website Features</h4>
                        <ul class="process-list half-description">
                            <li style="    max-width: 100%;display: block;flex: 0 0 100%;">
                                <div class="list-title  list-space">

                                    <p class="para">
                                        Navigation of the website was quite easy and hassle-free and kept with the
                                        step-by-step guide system. The users will get all the steps as they will apply
                                        to add the list of the products that they would like to add.
                                        The features and functionalities in the ZonSteps website were added to make
                                        businesses of every spectrum grow among the competitors.
                                    </p>

                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Step-by-step guide system
                                    </p>
                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Various categories available for every business industry
                                    </p>
                                </div>


                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Easy navigation
                                    </p>
                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        Good UI/UX
                                    </p>
                                </div>

                                <div class="list-title list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        There is a subscription for different phases of adding the businesses
                                    </p>
                                </div>

                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>